export default (axios, path = '/campaign') => ({
  purchase: async ({adTypeId, productId, locationIds, dayTimes}) => {
    return await axios.post(`${path}`, {
      adTypeId,
      productId,
      locationIds,
      dayTimes,
    })
  },
  findAllCurrentByGameId: async (gameId) => {
    return await axios.get(`${path}/game/${gameId}`)
  },
  findAllCurrentByTeamId: async (teamId) => {
    return await axios.get(`${path}/team/${teamId}`)
  },
  findAllArchivedByTeamId: async (teamId) => {
    return await axios.get(`${path}/team/${teamId}/archived`)
  },
  update: async (campaign) => {
    return await axios.post(`${path}/${campaign.id}`, campaign)
  },
  delete: async (id) => {
    return await axios.delete(`${path}/${id}`)
  },
  lock: async (id) => {
    return await axios.put(`${path}/${id}/lock`)
  },
  unlock: async (id) => {
    return await axios.put(`${path}/${id}/unlock`)
  },
})
